// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Chat_mainContainer__26lyc","pageContainer":"Chat_pageContainer__2IHLP","contentContainer":"Chat_contentContainer__2X7eO"};